var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"consumer-app"},[_c('dashboard-navbar'),_c('router-view',{staticStyle:{"margin-top":"138px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }